import image1 from '../../assets/images/backgroundImages/background-1.jpg'
import image2 from '../../assets/images/backgroundImages/background-2.jpg'
import image3 from '../../assets/images/backgroundImages/background-3.jpg'
import image4 from '../../assets/images/backgroundImages/background-4.jpg'
import image5 from '../../assets/images/backgroundImages/background-5.jpg'
import image6 from '../../assets/images/backgroundImages/background-6.jpg'
import image7 from '../../assets/images/backgroundImages/background-7.jpg'
import image8 from '../../assets/images/backgroundImages/background-8.jpg'
import image9 from '../../assets/images/backgroundImages/background-9.jpg'
import image10 from '../../assets/images/backgroundImages/background-10.jpg'
import image11 from '../../assets/images/backgroundImages/background-11.jpg'
import image12 from '../../assets/images/backgroundImages/background-12.jpg'
import image13 from '../../assets/images/backgroundImages/background-13.jpg'
import image14 from '../../assets/images/backgroundImages/background-14.jpg'
import image15 from '../../assets/images/backgroundImages/background-15.jpg'
import image16 from '../../assets/images/backgroundImages/background-16.jpg'
import image17 from '../../assets/images/backgroundImages/background-17.jpg'
import image18 from '../../assets/images/backgroundImages/background-18.jpg'
import image19 from '../../assets/images/backgroundImages/background-19.jpg'
import image20 from '../../assets/images/backgroundImages/background-20.jpg'
import image21 from '../../assets/images/backgroundImages/background-21.jpg'
import image22 from '../../assets/images/backgroundImages/background-22.jpg'
import image23 from '../../assets/images/backgroundImages/background-23.jpg'
import image24 from '../../assets/images/backgroundImages/background-24.jpg'
import image25 from '../../assets/images/backgroundImages/background-25.jpg'
import image26 from '../../assets/images/backgroundImages/background-26.jpg'
import image27 from '../../assets/images/backgroundImages/background-27.jpg'
import image28 from '../../assets/images/backgroundImages/background-28.jpg'
import image29 from '../../assets/images/backgroundImages/background-29.jpg'
import image30 from '../../assets/images/backgroundImages/background-30.jpg'
import image31 from '../../assets/images/backgroundImages/background-31.jpg'
import image32 from '../../assets/images/backgroundImages/background-32.jpg'
import image33 from '../../assets/images/backgroundImages/background-33.jpg'
import image34 from '../../assets/images/backgroundImages/background-34.jpg'
import image35 from '../../assets/images/backgroundImages/background-35.jpg'
import image36 from '../../assets/images/backgroundImages/background-36.jpg'
import image37 from '../../assets/images/backgroundImages/background-37.jpg'

const imageArray = [
        image1, image2, image3, image4, image5, image6, image7, image8, image9, image10, 
        image11, image12, image13, image14, image15, image16, image17, image18, image19, 
        image20, image21, image22, image23, image24, image25, image26, image27, image28, 
        image29, image30, image31, image32, image33, image34, image35, image36, image37
]

const getBackgroundImage = (imageID) => {
        return imageArray[Math.floor(Math.random() * imageArray.length)]
}

export default getBackgroundImage